import script from "./auth-phone-form.vue?vue&type=script&lang=ts&setup=true"
export * from "./auth-phone-form.vue?vue&type=script&lang=ts&setup=true"

import "./auth-phone-form.vue?vue&type=style&index=0&id=39453e8e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39453e8e"]])

export default __exports__